export default () => {
  return import(/* webpackChunkName: "vconsole" */ 'vconsole')
  .then(({ default: vConsole }) => {
    const vConsoleInstance = new vConsole()
    return {
      vConsole,
      vConsoleInstance,
    }
  })
}
